<script>
import { mapState, mapActions } from "vuex";

export default {
	name: "hakAkses",
	components: {
		// CardProduk
	},
	data() {
		return {
			userID: 0,
			info: {},
			currentPage: 1,
			totalPages: 0,
			loading: true,
		};
	},
	created() {
		console.log("asd");
	},
	mounted() {
		if (typeof this.$route.params.id !== "undefined") {
			this.findAll(this.$route.params.id);
			this.userID = this.$route.params.id;
		} else {
			this.$router.push("/pengguna");
		}
	},
	computed: {
		...mapState({
			myData: (state) => state.pengguna.menu,
		}),
		isLoading() {
			return this.$store.state.isLoading;
		},
	},
	methods: {
		...mapActions({
			getMenu: "pengguna/getMenu",
			saveMenu: "pengguna/saveMenu",
		}),
		findAll(id) {
			this.getMenu(id);
		},
		refreshData() {
			this.getMenu(this.userID);
		},
		simpanData() {
			this.saveMenu(this.myData).then((response) => {
				this.$toast.success(JSON.stringify(response.data));
				this.findAll(this.userID);
			});
		},
	},
};
</script>

<template>
	<div>
		<Breadcrumbs title="Pengguna - Hak Akses" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="card">
				<div class="card-header">
					<div class="row">
						<div class="col-sm-6 create-project-btn"></div>
						<div class="col-sm-6 create-project-btn">
							<div class="text-right">
								<b-button-group class="btn-group-pill">
									<b-button
										variant="primary"
										size="sm"
										@click="$router.push('/pengguna')"
										v-b-tooltip.hover
										title="Kembali"
										><i class="fa fa-fw fa-long-arrow-left"></i
									></b-button>
									<b-button
										variant="primary"
										size="sm"
										@click="refreshData()"
										v-b-tooltip.hover
										title="Refesh"
									>
										<div
											v-show="isLoading"
											class="spinner-border spinner-border-sm text-light"
											role="status"
											aria-hidden="true"
										></div>
										<i class="fa fa-refresh" v-show="!isLoading"></i
									></b-button>

									<b-button
										variant="primary"
										size="sm"
										@click="simpanData()"
										type="submit"
										form="form-data"
										v-b-tooltip.hover
										title="Simpan"
										><i class="fa fa-fw fa-save"></i
									></b-button>
								</b-button-group>
							</div>
						</div>
					</div>
				</div>

				<div class="card-body">
					<b-skeleton-wrapper :loading="!isLoading">
						<b-skeleton-table
							:rows="5"
							:columns="4"
							:table-props="{ bordered: true, striped: true }"
							animation="throb"
						></b-skeleton-table>
					</b-skeleton-wrapper>

					<template v-if="!isLoading">
						<form @submit.prevent="simpanData" id="form-data">
							<table class="table">
								<thead>
									<tr>
										<th scope="col">#</th>
										<th scope="col">Menu</th>
										<th scope="col">Aktif</th>
										<th scope="col">Tambah/Create</th>
										<th scope="col">Edit/Update</th>
										<th scope="col">Hapus/Delete</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(item, index) in myData"
										:key="item.menu_id"
									>
										<th scope="row">{{ index + 1 }}</th>
										<td>{{ item.nama }}</td>
										<td>
											<div class="media">
												<div
													class="media-body text-left icon-state switch-outline"
												>
													<label class="switch">
														<input
															type="checkbox"
															checked=""
															v-model="item.status"
														/><span
															class="switch-state bg-primary"
														></span>
													</label>
												</div>
											</div>
										</td>
										<td>
											<div class="custom-radio-ml">
												<div class="checkbox checkbox-primary">
													<b-form-checkbox
														name="checkbox4"
														v-model="item._create"
													></b-form-checkbox>
												</div>
											</div>
										</td>
										<td>
											<div class="custom-radio-ml">
												<div class="checkbox checkbox-primary">
													<b-form-checkbox
														name="checkbox4"
														v-model="item._update"
													></b-form-checkbox>
												</div>
											</div>
										</td>
										<td>
											<div class="custom-radio-ml">
												<div class="checkbox checkbox-primary">
													<b-form-checkbox
														name="checkbox4"
														v-model="item._delete"
													></b-form-checkbox>
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</form>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
nav.smart-pagination {
	margin-top: 20px;
}
</style>